"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaffMetaModel = void 0;
const QueryFieldKey_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldKey"));
const ViewFieldKey_1 = __importDefault(require("@opsbase/lib-data-viewfield/ViewFieldKey"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const MetaModel_1 = __importDefault(require("../MetaModel"));
exports.StaffMetaModel = new MetaModel_1.default({
    name: () => lib_i18n_1.default.t('staff'),
    queryName: 'staff',
    canImportData: true,
    canExportData: true,
    filterables: [
        QueryFieldKey_1.default.KEYWORD,
        QueryFieldKey_1.default.PLACE,
        QueryFieldKey_1.default.TEAM,
        QueryFieldKey_1.default.POSITION,
        QueryFieldKey_1.default.STAFF_TYPE,
        QueryFieldKey_1.default.STAFF_APPSTATUS,
        QueryFieldKey_1.default.STAFF_WEBSTATUS,
    ],
    groupables: [QueryFieldKey_1.default.PLACE, QueryFieldKey_1.default.TEAM, QueryFieldKey_1.default.POSITION, QueryFieldKey_1.default.STAFF_TYPE, QueryFieldKey_1.default.STAFF_APPSTATUS],
    fields: [
        ViewFieldKey_1.default.ID,
        ViewFieldKey_1.default.TITLE,
        ViewFieldKey_1.default.STAFF_TYPE,
        ViewFieldKey_1.default.ASSIGNED_PLACES,
        ViewFieldKey_1.default.EMAIL,
        ViewFieldKey_1.default.TEL,
        ViewFieldKey_1.default.STAFF_INVITETOAPPSTATUS,
        ViewFieldKey_1.default.STAFF_INVITESTATUS,
        ViewFieldKey_1.default.STAFF_LASTLOGGEDIN,
        ViewFieldKey_1.default.STAFF_POSITIONTEAMS,
        ViewFieldKey_1.default.STAFF_POSITIONS,
    ],
});
exports.default = exports.StaffMetaModel;
